import '../styles/index.scss';

// change theme upon projects enter
const projects = document.querySelector('.projects');

function changeTheme() {
  const projectsY = projects.getBoundingClientRect().top;

  document.body.classList.toggle(
    'dark',
    projectsY <= 200
  );
}

window.addEventListener('scroll', changeTheme, { passive: true });
changeTheme();

// cursor
const cursor = document.querySelector('.cursor');
const links = document.querySelectorAll('a');

document.addEventListener('mousemove', (e) => {
  cursor.style.left = e.pageX + 'px';
  cursor.style.top = e.pageY + 'px';
});

links.forEach((link) => {
  link.addEventListener('mouseenter', () => {
    cursor.style.width = '25px';
    cursor.style.height = '25px';
  });

  link.addEventListener('mouseleave', () => {
    cursor.style.width = '50px';
    cursor.style.height = '50px';
  });
});